import CssBaseline from '@mui/material/CssBaseline'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { RouterProvider } from 'react-router-dom'
import theme from './config/theme'
import './expanded-theme'
import './global.css'
import './initFirebase'
import DataDogProvider from './providers/DataDogProvider'
import ErrorBoundaryProvider from './providers/ErrorBoundary'
import FeatureTogglesProvider from './providers/FeatureToggles'
import GoogleTagManagerProvider from './providers/GoogleTagManagerProvider'
import { router } from './views/Router'

declare namespace AppleSignInAPI {
  interface AppleID {
    auth: {
      init: (config: any) => void
      renderButton: () => void
      signIn: () => Promise<any>
    }
  }
}

declare global {
  interface Window {
    AppleID: AppleSignInAPI.AppleID
    dataLayer?: Record<string, any>[]
  }
}

export default function App() {
  return (
    <GoogleTagManagerProvider>
      <ErrorBoundaryProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <DataDogProvider>
              <FeatureTogglesProvider>
                <CssBaseline />
                <RouterProvider router={router} />
              </FeatureTogglesProvider>
            </DataDogProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </ErrorBoundaryProvider>
    </GoogleTagManagerProvider>
  )
}
